// Pure Schema.org builders (no imports) — shared by the app and the build-time prerender.
export const SITE_NAME = "CJB Clean";
export const SITE_URL = "https://cjbclean.com";
export const ORG_ID = `${SITE_URL}/#business`;
export const WEBSITE_ID = `${SITE_URL}/#website`;
export const PHONE = "+1-703-249-9327";
export const EMAIL = "hello@cjbclean.com";
export const SAME_AS = [
  "https://www.google.com/maps?cid=7621635181675803498",
  "https://www.yelp.com/biz/cjb-clean-alexandria",
];
export const CITIES = [
  ["Alexandria", "VA"], ["Arlington", "VA"], ["McLean", "VA"], ["Tysons", "VA"], ["Falls Church", "VA"],
  ["Fairfax", "VA"], ["Vienna", "VA"], ["Springfield", "VA"], ["Annandale", "VA"],
  ["Washington", "DC"], ["Bethesda", "MD"], ["Silver Spring", "MD"],
];
export const SERVICES = [
  { name: "Standard Cleaning", url: "/services/standard-cleaning" },
  { name: "Deep Cleaning", url: "/services/deep-cleaning" },
  { name: "Move-In / Move-Out Cleaning", url: "/services/move-in-move-out-cleaning" },
  { name: "Recurring Cleaning", url: "/services/recurring-cleaning" },
  { name: "Commercial Cleaning", url: "/services/commercial-cleaning" },
];

const REGIONS = ["Northern Virginia", "Washington, DC", "Maryland"];
const city = ([n, s]) => ({ "@type": "City", name: `${n}, ${s}` });
export const AREA_SERVED = [
  ...REGIONS.map((name) => ({ "@type": "AdministrativeArea", name })),
  ...CITIES.map(city),
];

export function businessNode() {
  return {
    "@type": ["LocalBusiness", "HouseCleaningService"],
    "@id": ORG_ID,
    name: SITE_NAME,
    legalName: "CJB Solutions LLC",
    naics: "561720",
    identifier: [
      { "@type": "PropertyValue", propertyID: "UEI", value: "UXLLQKVY3X91" },
      { "@type": "PropertyValue", propertyID: "CAGE", value: "15ZF5" },
    ],
    hasCredential: [
      { "@type": "EducationalOccupationalCredential", name: "SBA Women-Owned Small Business (WOSB) Certified", recognizedBy: { "@type": "GovernmentOrganization", name: "U.S. Small Business Administration" } },
      { "@type": "EducationalOccupationalCredential", name: "SBA Economically Disadvantaged Women-Owned Small Business (EDWOSB) Certified", recognizedBy: { "@type": "GovernmentOrganization", name: "U.S. Small Business Administration" } },
      { "@type": "EducationalOccupationalCredential", name: "Virginia SWaM Certified", recognizedBy: { "@type": "GovernmentOrganization", name: "Virginia Department of Small Business & Supplier Diversity" } },
    ],
    url: SITE_URL,
    telephone: PHONE,
    email: EMAIL,
    image: `${SITE_URL}/assets/og-image.png`,
    logo: `${SITE_URL}/assets/cjb-logo.png`,
    description:
      "Woman-owned, SWaM-certified cleaning company in Alexandria, VA. Certified green cleaning professionals for residential and commercial spaces across Northern Virginia, Washington DC and Maryland. Offers recurring cleaning with a 24-hour redo guarantee, move-in/move-out cleaning and deep cleaning.",
    slogan: "Healthy Spaces. Smarter Solutions. Reliable Service.",
    address: { "@type": "PostalAddress", addressLocality: "Alexandria", addressRegion: "VA", addressCountry: "US" },
    areaServed: AREA_SERVED,
    hasMap: SAME_AS[0],
    sameAs: SAME_AS,
    priceRange: "$$",
    openingHoursSpecification: [
      { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "07:00", closes: "19:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: ["Saturday"], opens: "10:00", closes: "17:00" },
    ],
    knowsAbout: ["Green cleaning", "House cleaning", "Deep cleaning", "Move-in and move-out cleaning", "Recurring cleaning", "Commercial cleaning"],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Cleaning Services",
      itemListElement: SERVICES.map((s) => ({
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: s.name, url: SITE_URL + s.url },
      })),
    },
  };
}

export function siteGraph() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      { "@type": "WebSite", "@id": WEBSITE_ID, url: SITE_URL, name: SITE_NAME, inLanguage: "en-US", publisher: { "@id": ORG_ID } },
      businessNode(),
    ],
  };
}

export function webPageSchema({ path, name, description, type = "WebPage" }) {
  return {
    "@context": "https://schema.org",
    "@type": type,
    "@id": `${SITE_URL}${path}#webpage`,
    url: SITE_URL + path,
    name,
    description,
    isPartOf: { "@id": WEBSITE_ID },
    about: { "@id": ORG_ID },
    ...(type !== "WebPage" ? { mainEntity: { "@id": ORG_ID } } : {}),
  };
}

export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function serviceSchema({ name, description, path, areaServed = AREA_SERVED }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    name: `${name} — CJB Clean`,
    provider: { "@id": ORG_ID },
    areaServed,
    description,
    ...(path ? { url: SITE_URL + path } : {}),
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem", position: i + 1, name: it.name, item: SITE_URL + it.path,
    })),
  };
}
